import instance from "../axios/axios";

// Fetch all inventory items with pagination and search
export const getInventoryItems = async ({ page, limit, search }) => {
    try {
        const response = await instance.get(`/api/inventory/items?page=${page}&limit=${limit}&search=${search}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Create a new inventory item
export const createInventoryItem = async (itemData) => {
    try {
        const response = await instance.post('/api/inventory/items', itemData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Update an existing inventory item
export const updateInventoryItem = async (id, itemData) => {
    try {
        const response = await instance.put(`/api/inventory/items/${id}`, itemData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Delete an inventory item
export const deleteInventoryItem = async (id) => {
    try {
        const response = await instance.delete(`/api/inventory/items/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Update item quantity
export const updateItemQuantity = async (id, increment) => {
    try {
        const response = await instance.patch(`/api/inventory/items/${id}/quantity`, { increment });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};